import { render } from "./Phone.vue?vue&type=template&id=1ff7afea&scoped=true"
import script from "./Phone.vue?vue&type=script&lang=js"
export * from "./Phone.vue?vue&type=script&lang=js"

import "./Phone.vue?vue&type=style&index=0&id=1ff7afea&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Дентакорплюс\\dentakor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff7afea"]])

export default __exports__